import { useContext } from "react";

import { ChannelsContext } from "./ChannelsContext";
import { ChannelsContextType } from "./ChannelsContext";

export const useChannels = (): ChannelsContextType => {
  const context = useContext(ChannelsContext);

  if (!context) {
    throw new Error("useChannels must be used within a ChannelsProvider");
  }

  return context;
}; 